import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=70b07126&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=70b07126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b07126",
  null
  
)

export default component.exports